
export const perfisUnidadeGerencia = ['ENCARREGADO', 'GERENTE'];

export const perfisVisitante = ['VISITANTE'];

export const perfisAdmin = ['AUDITOR'];

export const perfisAdminAndUnidade = ['AUDITOR', 'ENCARREGADO', 'GERENTE'];

export const perfisTodos = [...perfisAdmin, ...perfisUnidadeGerencia, ...perfisVisitante];